import src from "IMAGE";
export default { src, width: 262, height: 88, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAAAAACLoxGUAAAAJklEQVR42mP48vXLl89fv31juH754o1bd+48Yvj26ePXr9++fwcAKagWFD+ymQcAAAAASUVORK5CYII="};
